export const linkimage ={
    vanchuyenmaiphuong1:"https://i.pinimg.com/originals/59/ae/27/59ae270e22179b9b9f073e48e74f73a5.jpg",
    vanchuyenmaiphuong2:"https://i.pinimg.com/originals/91/6d/71/916d7194f0dbedf0eb03a825e09b1f25.jpg",
    vanchuyenmaiphuong3:"https://i.pinimg.com/originals/bc/71/52/bc7152e4343714b1b87c9c59b083d440.jpg",
    vanchuyenmaiphuongalt:"Vận chuyển nhật việt",

    content_2:"https://scontent-nrt1-1.xx.fbcdn.net/v/t1.0-9/99084786_2380465962252379_152682105938116608_n.jpg?_nc_cat=100&_nc_sid=110474&_nc_ohc=5i6DHicuC8QAX_mMzpn&_nc_ht=scontent-nrt1-1.xx&oh=408ba033e062d6f84cf4202cabea3674&oe=5F7DC669",
    content_1:"https://i.pinimg.com/originals/7a/06/3f/7a063f4d6cb1a218a178bbaf438a5b10.jpg",

    thanhVien_xuanhoai:"https://i.pinimg.com/originals/1e/f1/73/1ef173aaf228dd55b0ceee4a8aa6cdbe.jpg",
    thanhvien_thuphong:"https://i.pinimg.com/originals/86/b4/b9/86b4b9ea9188ccdd8c1fcbbcaafe215a.jpg",
    thanhvien_hanghang:"https://i.pinimg.com/originals/25/f5/21/25f521fd40aec6ccfb4cd8230b8486f9.jpg",
    thanhvien_hoangduy:"https://i.pinimg.com/originals/c5/94/ff/c594ff5d4746ec09dea87d0647705b03.jpg",
    thanhvien_maihuyen:"https://i.pinimg.com/originals/97/a1/fb/97a1fbf574d65297a3d6a99cf0d76f02.jpg",
    thanhvien_mailoan:"https://i.pinimg.com/originals/e1/a4/83/e1a48378629b1d15f7da7a409262d819.jpg",
    thanhvien_maile:"https://i.pinimg.com/originals/c8/64/a6/c864a667854d12b557e0ec907dd0977f.jpg",

}

export default linkimage